import styled from 'styled-components';

import {grey} from '@drivesally/sally-ui/lib/libs/colors';

const SlackChannelSection = styled.div`
  border-bottom: 1px solid ${grey};
  flex-shrink: 0;
  padding: 12px 20px;
`;

export default SlackChannelSection;
